import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import { ConnectivityProvider } from './context/ConnectivityContext';
import OfflineOverlay from './components/OfflineOverlay';

// Global error handler for uncaught errors (helps debug blank screen issues)
// IMPORTANT: Returns true to suppress browser's default error handling and prevent crashes
window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', { message, source, lineno, colno, error });
  // Try to display error on screen if React hasn't rendered
  const root = document.getElementById('root');
  if (root && !root.hasChildNodes()) {
    root.innerHTML = `
      <div style="background:#1a1a2e;color:#eee;padding:20px;min-height:100vh;font-family:monospace">
        <h1 style="color:#ff6b6b">JavaScript Error (Pre-React)</h1>
        <pre style="color:#feca57">${message}</pre>
        <pre style="color:#54a0ff">${source}:${lineno}:${colno}</pre>
        <pre style="color:#ff6b6b">${error?.stack || ''}</pre>
      </div>
    `;
  }
  // Return true to indicate error was handled (prevents browser default behavior)
  return true;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <ErrorBoundary>
      <ConnectivityProvider>
        <HashRouter>
          <Toaster />
          <OfflineOverlay />
          <App />
        </HashRouter>
      </ConnectivityProvider>
    </ErrorBoundary>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
